import React from "react";
import { twMerge } from "tailwind-merge";
import { useStore } from "../../store/store";

interface MoreInfoButtonProps {
  onClick?: () => void;
  className?: string;
}

const MoreInfoButton: React.FC<MoreInfoButtonProps> = ({
  onClick,
  className = "",
}) => {
  const { audioManager } = useStore();
  const classes = {
    wrapper: twMerge(
      "btn-more-info-wrapper inline-flex justify-center items-center pb-10 md:pb-8",
      className,
    ),
    button:
      "button btn-more-info flex justify-center items-center p-2 border-2 rounded-full text-white backdrop--blur bg-transparent transition",
    text: "text text-white inline-block ml-4 cursor-pointer",
  };

  const handleClick = (event: React.MouseEvent) => {
    audioManager!.play("click");
    if (onClick) onClick();
  };
  return (
    <div className={classes.wrapper}>
      <button type="button" className={classes.button} onClick={handleClick}>
        <span className="d-icon text-base flex items-center d-arrow-down"></span>
      </button>
      <span onClick={handleClick} className={classes.text}>
        Meer informatie
      </span>
    </div>
  );
};

export default MoreInfoButton;
